/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useState } from 'react';
import { url } from 'utils/urls';
// material
import { ReactComponent as ComposeIcon } from 'assets/icons/compose.svg'
import { Radio, Tip } from '@insticator/insticator-ui'
import Space from 'material/space/space';
import { SectionGroupV2, ConfigToggle } from 'material/expandablesection/v2'
// styles
import injectSheet from 'react-jss'
import styles from './guestcommenting_styles'
import PreviewConfig from '../../previewconfig/previewconfig';
import { TextField } from '@insticator/insticator-ui/dist/material';


/* ========== ~~~~~~~~~~ COMMENTING CONFIG V2: ADVANCED SECTION : GUEST COMMENTING ~~~~~~~~~~ ========== */
const GuestCommenting = injectSheet(styles)((props) => {

  const { allowGuestCommenting, useAutoGeneratedGuestUsername, customGuestUsername, onChange } = props

  return (
    <SectionGroupV2 title={'Guest Experience'} description={`Select how users without an account interact with comments.`}>
      <ConfigToggle 
        title={'Allow guest commenting'}
        description={'Users without an account can comment and reply.'}
        checked={allowGuestCommenting}
        onChange={val => onChange('allowGuestCommenting', val)}
      >
        <Space gap={48}>
          <Space direction={'column'}>
            <p>Choose guest user names</p>
            <Radio 
              isList={true}
              title={<span>Auto-generate <Tip space={'none'} icon={'question-circle'} content={'Auto-generated based on the "Avatar Pack" theme you selected. The names created will match the context of the theme. For example, if you selected "Sports", it will generate names like "BasketballWinner127".'} label={''} /></span>}
              checked={useAutoGeneratedGuestUsername}
              handleChange={() => {
                onChange('useAutoGeneratedGuestUsername', true)
              }}
            />
            <Radio 
              isList={true}
              title={<span>Custom prefix <Tip space={'none'} icon={'question-circle'} content={'Allows you to create a prefix that will show before a randomized generic username for all guest users. For example, typing "sports" will result in something like "sports_rah332".'} label={''} /></span>}
              checked={!useAutoGeneratedGuestUsername}
              handleChange={() => {
                onChange('useAutoGeneratedGuestUsername', false)
              }}
            />
            <TextField 
              type={`text`} 
              name={`guestcommenting`} 
              icon={<ComposeIcon />}
              value={customGuestUsername} 
              disabled={useAutoGeneratedGuestUsername}
              handleChange={e => {
                onChange('customGuestUsername', e.target.value)
              }}
              placeholder={`Enter a custom prefix for your guests user names`} 
              maxLength={20}
              required
              valid={useAutoGeneratedGuestUsername || !allowGuestCommenting ? true : !!customGuestUsername}
            />
          </Space>
          <PreviewConfig>
            <img width={24} height={24} src={`${url.image}/2.0/avatars/avatar-4.png`} />
            <span>
              { useAutoGeneratedGuestUsername ?
              `TrendyTempo`
              :
              `${customGuestUsername || ''}`
              }
            </span>
          </PreviewConfig>
        </Space>
      </ConfigToggle>
    </SectionGroupV2>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GuestCommenting;